var _rect, _rect2, _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRrIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 49,
    height: 49
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    rx: 4,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0511 28.0949V37H4V12H13.4891C19.1338 12 21.9562 14.6521 21.9562 19.9562C21.9562 23.5085 20.5937 25.9173 17.8686 27.1825L21.9927 37H17.5401L13.927 28.0949H8.0511ZM17.7956 19.9927C17.7956 17 16.3601 15.5036 13.4891 15.5036H8.0511V24.5912H13.562C15.0219 24.5912 16.0925 24.1776 16.7737 23.3504C17.455 22.4988 17.7956 21.3796 17.7956 19.9927Z",
    fill: "#2962FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6118 28.0949V37H26.5607V12H36.0498C41.6946 12 44.5169 14.6521 44.5169 19.9562C44.5169 23.5085 43.1544 25.9173 40.4293 27.1825L44.5534 37H40.1009L36.4877 28.0949H30.6118ZM40.3564 19.9927C40.3564 17 38.9208 15.5036 36.0498 15.5036H30.6118V24.5912H36.1228C37.5826 24.5912 38.6532 24.1776 39.3345 23.3504C40.0157 22.4988 40.3564 21.3796 40.3564 19.9927Z",
    fill: "#2962FF"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRrIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/RR-Icon.4c5fc3b7.svg";
export { ForwardRef as ReactComponent };